import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import env from '../config/env';

Vue.use(Vuex)

const baseURL = env.baseURL;
const normalURL = env.normalURL;

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
  state: {
    user: {
      name: '',
      cargo: '',
      photo: '',
      company_logo: '',
      company_name: '',
      job: '',
      email: '',
      is_admin: '',
      password_expired: 0,
      id: 0,
      setor: 0,
      local: 0,
      perfil_id: 0,
    },
    authenticated: false,
    notifications: 0,
    token: '',
    api: baseURL,
    url: normalURL,
    breadcrumbs: [{ name: "Home", route: "/" }],
    setores_chamador: JSON.parse(localStorage.getItem('setores_chamador') || '[]'),
    locais_chamador: JSON.parse(localStorage.getItem('locais_chamador') || '{}'),
    motivos_cancelamento: JSON.parse(localStorage.getItem('motivos_cancelamento') || '[]'),
    prioridades_cache: JSON.parse(localStorage.getItem('prioridades_cache') || '[]'),
    classificacoes_cache: JSON.parse(localStorage.getItem('classificacoes_cache') || 'null'),
    finalizacoes_cache: JSON.parse(localStorage.getItem('finalizacoes_cache') || 'null'),
    configuracao_cache: JSON.parse(localStorage.getItem('configuracao_cache') || 'null'),
    all_setores_cache: JSON.parse(localStorage.getItem('all_setores_cache') || '[]'),
    fluxo_setores_cache: JSON.parse(localStorage.getItem('fluxo_setores_cache') || '{}')
  },
  getters: {
    token: state => {
      return state.token;
    },
    authenticated: state => {
      if (state.token == null || state.token == 'null') {
        return false;
      }

      return state.authenticated;
    },
    logo: state => {
      return state.logo;
    },
    user: state => {
      return state.user;
    },
    api: state => {
      return state.api;
    },
    breadcrumbs: state => {
      return state.breadcrumbs;
    }
  },
  mutations: {
    auth(state, token) {

      if (token != null && token != undefined) {
        state.authenticated = true;
        state.token = token;

        // Preserva cache antes de limpar
        const setoresCache = state.setores_chamador;
        const locaisCache = state.locais_chamador;
        const motivosCache = state.motivos_cancelamento;
        const prioridadesCache = state.prioridades_cache;
        const classificacoesCache = state.classificacoes_cache;
        const finalizacoesCache = state.finalizacoes_cache;
        const configuracaoCache = state.configuracao_cache;
        const allSetoresCache = state.all_setores_cache;
        const fluxoSetoresCache = state.fluxo_setores_cache;

        localStorage.clear();
        localStorage.setItem('token', token);

        // Restaura caches preservados
        const restoreCache = (key, value) => {
          if (value && (Array.isArray(value) ? value.length : Object.keys(value).length))
            localStorage.setItem(key, JSON.stringify(value));
        };
        restoreCache('setores_chamador', setoresCache);
        restoreCache('locais_chamador', locaisCache);
        restoreCache('motivos_cancelamento', motivosCache);
        restoreCache('prioridades_cache', prioridadesCache);
        restoreCache('classificacoes_cache', classificacoesCache);
        restoreCache('finalizacoes_cache', finalizacoesCache);
        if (configuracaoCache) localStorage.setItem('configuracao_cache', JSON.stringify(configuracaoCache));
        restoreCache('all_setores_cache', allSetoresCache);
        restoreCache('fluxo_setores_cache', fluxoSetoresCache);

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
        this.commit('profileUpdate');
      }
    },
    updateNotifications(state, data) {
      state.notifications = Number(state.notifications) + 1;
    },
    profileUpdate(state) {
      axios.post(state.api + 'me', {
        token: state.token
      })
        .then(response => {
          state.user.id = response.data.id;
          state.user.name = response.data.name;
          state.user.cargo = response.data.cargo;
          state.user.email = response.data.email;
          state.user.photo = state.url + "user/image/" + response.data.id;
          state.user.company_logo = state.url + "companies/logo/" + response.data.company_id;
          state.user.company_name = response.data.company_name;
          state.user.cellphone = response.data.cellphone;
          state.user.password_expired = response.data.password_expired;
          state.user.setor = response.data.setor_logado;
          state.user.local = response.data.local_logado;
          state.user.perfil_id = response.data.perfil_id;

          localStorage.setItem('accept_terms', response.data.accept_terms);
          localStorage.setItem('perfil_id', response.data.perfil_id);

          // Pré-carrega setores do chamador para evitar requisição repetida
          axios.get(state.api + 'setores-chamador/' + response.data.id)
            .then(res => {
              const setores = res.data.filter(s => s.possui_local);
              state.setores_chamador = setores;
              localStorage.setItem('setores_chamador', JSON.stringify(setores));
            })
            .catch(() => {});

          // Pré-carrega fluxo de setores se o usuário já estiver logado num setor
          const setorLogado = response.data.setor_logado;
          if (setorLogado) {
            const fluxoExistente = state.fluxo_setores_cache[setorLogado];
            const fluxoData = fluxoExistente && Array.isArray(fluxoExistente.data)
              ? fluxoExistente.data
              : Array.isArray(fluxoExistente) ? fluxoExistente : [];
            if (!fluxoData.length) {
              axios.get(state.api + 'fluxo_setores?paginated=false&with[]=setor&ativo=1&setor_original_id=' + setorLogado)
                .then(res => {
                  const ativos = res.data.data.filter(f => f.setor && f.setor.ativo);
                  Vue.set(state.fluxo_setores_cache, setorLogado, { data: ativos, updatedAt: Date.now() });
                  localStorage.setItem('fluxo_setores_cache', JSON.stringify(state.fluxo_setores_cache));
                })
                .catch(() => {});
            }
          }

          // Pré-carrega dados estáticos do chamador
          if (!state.motivos_cancelamento.length) {
            axios.get(state.api + 'motivo_cancelamentos/')
              .then(res => {
                state.motivos_cancelamento = res.data.data;
                localStorage.setItem('motivos_cancelamento', JSON.stringify(res.data.data));
              })
              .catch(() => {});
          }

          if (!state.prioridades_cache.length) {
            axios.get(state.api + 'prioridades?paginated=false')
              .then(res => {
                state.prioridades_cache = res.data.data;
                localStorage.setItem('prioridades_cache', JSON.stringify(res.data.data));
              })
              .catch(() => {});
          }

          const CACHE_TTL = 3600000; // 1 hora
          const now = Date.now();

          const classifCache = state.classificacoes_cache;
          if (!classifCache || !classifCache.data || (now - classifCache.updatedAt > CACHE_TTL)) {
            axios.get(state.api + 'classificacoes?ativo=1&paginated=false')
              .then(res => {
                const payload = { data: res.data.data, updatedAt: Date.now() };
                state.classificacoes_cache = payload;
                localStorage.setItem('classificacoes_cache', JSON.stringify(payload));
              })
              .catch(() => {});
          }

          const finalCache = state.finalizacoes_cache;
          if (!finalCache || !finalCache.data || (now - finalCache.updatedAt > CACHE_TTL)) {
            axios.get(state.api + 'finalizacoes?paginated=false&ativo=1')
              .then(res => {
                const payload = { data: res.data.data, updatedAt: Date.now() };
                state.finalizacoes_cache = payload;
                localStorage.setItem('finalizacoes_cache', JSON.stringify(payload));
              })
              .catch(() => {});
          }

          const configCache = state.configuracao_cache;
          if (!configCache || !configCache.data || (now - configCache.updatedAt > CACHE_TTL)) {
            axios.get(state.api + 'configuracoes/')
              .then(res => {
                const payload = { data: res.data.data[0], updatedAt: Date.now() };
                state.configuracao_cache = payload;
                localStorage.setItem('configuracao_cache', JSON.stringify(payload));
              })
              .catch(() => {});
          }

          if (!state.all_setores_cache.length) {
            axios.get(state.api + 'setores?ativo=1&paginated=false')
              .then(res => {
                state.all_setores_cache = res.data.data;
                localStorage.setItem('all_setores_cache', JSON.stringify(res.data.data));
              })
              .catch(() => {});
          }

        })
        .catch(error => {
          // Não limpa todo o localStorage para preservar os caches
          localStorage.removeItem('token');
          state.authenticated = false;
          state.token = '';

          router.push('/login');
        });
    },
    setSetoresChamador(state, setores) {
      state.setores_chamador = setores;
      localStorage.setItem('setores_chamador', JSON.stringify(setores));
    },
    setLocaisChamador(state, { setorId, locais }) {
      Vue.set(state.locais_chamador, setorId, locais);
      localStorage.setItem('locais_chamador', JSON.stringify(state.locais_chamador));
    },
    setMotivosCancelamento(state, motivos) {
      state.motivos_cancelamento = motivos;
      localStorage.setItem('motivos_cancelamento', JSON.stringify(motivos));
    },
    setPrioridadesCache(state, prioridades) {
      state.prioridades_cache = prioridades;
      localStorage.setItem('prioridades_cache', JSON.stringify(prioridades));
    },
    setClassificacoesCache(state, classificacoes) {
      state.classificacoes_cache = classificacoes;
      localStorage.setItem('classificacoes_cache', JSON.stringify(classificacoes));
    },
    setFinalizacoesCache(state, finalizacoes) {
      state.finalizacoes_cache = finalizacoes;
      localStorage.setItem('finalizacoes_cache', JSON.stringify(finalizacoes));
    },
    setConfiguracaoCache(state, configuracao) {
      state.configuracao_cache = configuracao;
      localStorage.setItem('configuracao_cache', JSON.stringify(configuracao));
    },
    setAllSetoresCache(state, setores) {
      state.all_setores_cache = setores;
      localStorage.setItem('all_setores_cache', JSON.stringify(setores));
    },
    setFluxoSetoresCache(state, { setorId, fluxo }) {
      Vue.set(state.fluxo_setores_cache, setorId, fluxo);
      localStorage.setItem('fluxo_setores_cache', JSON.stringify(state.fluxo_setores_cache));
    },
    clearChamadorCache(state) {
      state.setores_chamador = [];
      state.locais_chamador = {};
      localStorage.removeItem('setores_chamador');
      localStorage.removeItem('locais_chamador');
    },
    setChamador(state, obj) {
      state.user.setor = obj.setor;
      state.user.local = obj.local;
    },
    setApi(state, newApi) {
      state.url = newApi;
      state.api = newApi + 'api/v1/';
    },
    updateBreadCrumbs(state, newRoute) {
      if (state.breadcrumbs.length > 1) {
        state.breadcrumbs.pop();
      }
      state.breadcrumbs.push(newRoute)
      // state.breadcrumbs = newRoute;
    }
  },
  actions: {
    initialize(context) {
      const token = localStorage.getItem('token');
      context.commit('auth', token);
    }
  },
})
